import styled from 'styled-components';

const NarrowContent = styled.div`
  max-width: 682px;
  margin-left: auto;
  margin-right: auto;
`;

export default NarrowContent;
